import { render, staticRenderFns } from "./dispalyRules.vue?vue&type=template&id=e6435f12&scoped=true&"
import script from "./dispalyRules.vue?vue&type=script&lang=ts&"
export * from "./dispalyRules.vue?vue&type=script&lang=ts&"
import style0 from "./dispalyRules.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dispalyRules.vue?vue&type=style&index=1&id=e6435f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6435f12",
  null
  
)

export default component.exports